import { render } from "./Base.vue?vue&type=template&id=8fa95bb8&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=8fa95bb8&lang=scss&scoped=true"
import "./Base.vue?vue&type=style&index=1&id=8fa95bb8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa95bb8"]])

export default __exports__